import { FC } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import { colors } from '@lmc/common/constants'
import Field from '../../fields'
import { Home, Resident } from '@lmc/ts-common'
import { isSeizureItemLog } from 'screens/Logs/LogScreen/components/utils'

interface Props {
  selectedResident?: Resident
  fields: Array<Record<string, any>>
  formId: string
  item: {
    amountOneKey?: string
    amountTwoKey?: string
    id?: string
  }
  features?: Home
  testId?: string
}

const ModalTitleSelector: FC<Props> = ({ fields, formId, item, testId }) => {
  const renderMeasurementField = ({
    key,
    amountKey,
    fields,
    formId,
  }: {
    key: string
    amountKey: string
    fields: Array<Record<string, any>>
    formId: string
  }) => (
    <Field
      formId={formId}
      keys={key}
      amountKey={amountKey}
      layout="column"
      type="measurement"
      positiveValuesOnly={key === 'amount1'}
      values={fields}
    />
  )

  const showMeasurements = !isSeizureItemLog(item?.id)

  return (
    <div
      className={css(classes.container)}
      data-testid={testId || 'modal-title-selector'}
    >
      <div
        className={css(classes.formField)}
        data-cy="title-input-form"
        data-testid={
          testId ? `${testId}-title-field` : 'modal-title-selector-title-field'
        }
      >
        <Field
          id="form-title"
          formId={formId}
          keys="title"
          label="Title"
          layout="column"
          required
          type="text"
          values={fields}
          data-testid={
            testId
              ? `${testId}-title-input`
              : 'modal-title-selector-title-input'
          }
        />
      </div>
      <div
        className={css(classes.formField)}
        data-cy="description-input-form"
        data-testid={
          testId
            ? `${testId}-description-field`
            : 'modal-title-selector-description-field'
        }
      >
        <Field
          id="form-description"
          formId={formId}
          keys="description"
          label="Description"
          layout="column"
          required
          type="textarea"
          values={fields}
          data-testid={
            testId
              ? `${testId}-description-input`
              : 'modal-title-selector-description-input'
          }
        />
        <p
          className={css(classes.helpText)}
          data-testid={
            testId ? `${testId}-help-text` : 'modal-title-selector-help-text'
          }
        >
          {HELP_TEXT}
        </p>
      </div>
      {showMeasurements && item?.amountOneKey && (
        <div
          className={css(classes.formField)}
          data-cy="amount-input-form"
          data-testid={
            testId
              ? `${testId}-amount1-field`
              : 'modal-title-selector-amount1-field'
          }
        >
          {renderMeasurementField({
            key: 'amount1',
            amountKey: item.amountOneKey,
            fields,
            formId,
          })}
        </div>
      )}
      {showMeasurements && item?.amountTwoKey && (
        <div
          className={css(classes.formField)}
          data-cy="amount-input-form"
          data-testid={
            testId
              ? `${testId}-amount2-field`
              : 'modal-title-selector-amount2-field'
          }
        >
          {renderMeasurementField({
            key: 'amount2',
            amountKey: item.amountTwoKey,
            fields,
            formId,
          })}
        </div>
      )}
    </div>
  )
}

const HELP_TEXT = 'This text will be visible to your carers in the Carer App'

const classes = StyleSheet.create({
  container: {
    maxWidth: 400,
    margin: 'auto',
  },
  label: {
    textAlign: 'left',
    fontWeight: 'bold',
  },
  formField: {
    paddingBottom: 14,
    maxWidth: 400,
  },
  nextButton: {
    marginTop: 60,
  },
  helpText: {
    fontSize: 12,
    marginBottom: 0,
    marginTop: 4,
    color: colors.darkgrey,
  },
  required: {
    fontStyle: 'italic',
    fontWeight: 300,
  },
})

export default ModalTitleSelector
